"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.absenceTypesRepository = void 0;
const RepositoryReact_1 = __importDefault(require("../../React/RepositoryReact"));
/**
 * Słownik typów nieobecności (urlopy, opieka, L4).
 * Trasy za bramką /admin - dostęp mają ADMIN i ENVI_MANAGER.
 */
exports.absenceTypesRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "admin/absenceTypes",
        addNewRoute: "admin/absenceType",
        editRoute: "admin/absenceType",
        deleteRoute: "admin/absenceType",
    },
    name: "absenceTypes",
});
